import { connect } from "react-redux";
import AccountPeople from "./AccountPeople";
import { fetchUsers } from "./actions/users";
import { prepareUsers } from "./helpers/users";

const mapStateToProps = (state, ownProps) => {
  const users = prepareUsers(
    state.entities.users,
    ownProps.account.id,
    state.ui.sortPeople
  );

  return {
    users: users,
    loading: state.ui.loadingUsers
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchUsers: () => {
      const params = {
        filters: {
          account: ownProps.account.id
        },
        limit: 2000
      };
      dispatch(fetchUsers(params));
    }
  };
};

const AccountPeopleContainer = connect(mapStateToProps, mapDispatchToProps)(
  AccountPeople
);

export default AccountPeopleContainer;



// WEBPACK FOOTER //
// ./src/AccountPeopleContainer.js